import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";

export interface TimerResponse {
  msg: string;
  status: string;
  isAlreadyStarted: boolean;
  data: {
    type: string;
    _id: string;
    patientId: {
      primaryInsurance: {
        provider: string;
        policyNumber: string;
        groupNumber: string;
      };
      secondaryInsurance: {
        provider: string;
        policyNumber: string;
        groupNumber: string;
      };
      name: string;
      firstName: string;
      middleName: string;
      lastName: string;
      uploadFolder: any[];
      bestTimeToContact: string;
      photo: string;
      role: string;
      rtmStatus: string;
      timezone: string;
      passwordChangedAt: string;
      active: boolean;
      latitude: string;
      longitude: string;
      distance: number;
      age: number;
      dob: string;
      dobString: string;
      gender: string;
      stripeCustomerID: string;
      userDeviceID: string;
      clinicID: string;
      nextGenClinicId: string;
      isNextGenUser: boolean;
      nextGenPatientId: string;
      medicalRecordNumber: string;
      personNumber: string;
      clinicType: string;
      ehr: string;
      enterpriseId: string;
      practiceId: string;
      practiceLocationId: string;
      permanentlyDelete: boolean;
      providerId: string;
      contactName: string;
      homePhone: string;
      isFirstLogin: boolean;
      _id: string;
      email: string;
      phone: string;
      clinic: string;
      associatedClinicId: string;
      billingProviderId: string;
      clinicianId: string;
      address1: string;
      address2: string;
      city: string;
      state: string;
      zip: string;
      address: string;
      createdAt: string;
      updatedAt: string;
      __v: number;
    };
    associatedClinicianId: string;
    clinicianId: string;
    clinic: string;
    startTimerTimestamp: string;
    startTimerLocal: string;
    startTimerTimestampUtc: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
}

const useFloatingTimer = () => {
  const [floatingTimer, setFloatingTimer] = React.useState<
    TimerResponse | undefined
  >(undefined);

  const { loading: loadingFloatingTimer, makeApiCall } = useApi({
    url: `/rtm/timer/clinician/status`,
    method: "GET",
  });

  const getFloatingTimer = async () => {
    const { response, error } = await makeApiCall<undefined, TimerResponse>();

    if (response?.status && response) {
      setFloatingTimer(response);
    }
    if (error) {
      toast.error(error.msg);
      setFloatingTimer(undefined);
    }
  };

  return {
    floatingTimer,
    getFloatingTimer,
    loadingFloatingTimer,
  };
};

export default useFloatingTimer;
